import { autoinject, transient } from "aurelia-framework";
import { MessageCenterAccessModel } from "../../../../../models/message-centre.models";

@autoinject
@transient()
export class PageActionsAvailable {

    public imgUrl: string = require('../../../../../images/quickstart/03.png');

    constructor() { }

    public model: MessageCenterAccessModel;

    activate(model: MessageCenterAccessModel) {
        this.model = model;
    }

    onReviseProposal() {
        this.model.reviseProposal();   
    }

    onWithdrawInspection() {
        this.model.withdrawInspection();   
    }

    onChangeInspectionDate() {
        this.model.changeInspectionDate();
    }

    onCancelInspection() {
        this.model.cancelInspection();
    }

    onStartNewConversation() {
        this.model.startNewConversation();
    }
}
